module.exports = __webpack_public_path__ + "media/packs/images/flags/LV-140d8a7b1487f1d7625e24c10560f6d8.svg";